import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Sousuo from "../pages/sousuo/page";
import Guanyu from "../pages/guanyu/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sousuo",
    element: <Sousuo />,
  },
  {
    path: "/guanyu",
    element: <Guanyu />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;